/**
 * Phone number validation utilities for 2FA
 */

/**
 * Validates a phone number for 2FA purposes
 * @param phone - The phone number to validate
 * @returns boolean indicating if the phone number is valid
 */
export function validatePhoneNumber(phone: string): boolean {
	// Basic validation: should be at least 10 digits (excluding country code)
	const digitsOnly = phone.replace(/\D/g, "");
	return digitsOnly.length >= 10 && digitsOnly.length <= 15;
}

/**
 * Masks a phone number for privacy in logs/UI
 * @param phoneNumber - The phone number to mask
 * @returns Masked phone number (e.g., +1234***7890)
 */
export function maskPhoneNumber(phoneNumber: string): string {
	if (!phoneNumber || phoneNumber.length < 4) {
		return phoneNumber;
	}

	const visiblePrefix = phoneNumber.substring(0, 3);
	const visibleSuffix = phoneNumber.slice(-4);
	const maskedPart = "*".repeat(Math.max(0, phoneNumber.length - 7));

	return `${visiblePrefix}${maskedPart}${visibleSuffix}`;
}

/**
 * Formats phone number to E.164 format for API calls
 * @param phoneNumber - The phone number to format
 * @returns E.164 formatted phone number
 */
export function formatPhoneForAPI(phoneNumber: string): string {
	return phoneNumber.startsWith("+") ? phoneNumber : `+${phoneNumber}`;
}
